import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ZonalStatementPage } from '@/features/zonalStatement/pages/ZonalStatementPage';
import { zonalStatementSearchSchema } from '@/features/zonalStatement/types/zonalStatement.types';

export const Route = createFileRoute('/_auth/dashboards/zonal-statement/')({
  validateSearch: zonalStatementSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Zonal Statement">
      <Suspense fallback={<PageLoader />}>
        <ZonalStatementPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
